export const APIUrl = "https://www.foxcloud.ro:44367";
export const ImagesServiceUrl = "https://www.foxcloud.ro:44367/Images";

// export const APIUrl = "https://localhost:44367";
// export const ImagesServiceUrl = "https://localhost:44367/Images";